import { render, staticRenderFns } from "./studentCard.vue?vue&type=template&id=459b87fa&scoped=true"
import script from "./studentCard.vue?vue&type=script&lang=js"
export * from "./studentCard.vue?vue&type=script&lang=js"
import style0 from "./studentCard.vue?vue&type=style&index=0&id=459b87fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459b87fa",
  null
  
)

export default component.exports